module.exports = __webpack_public_path__ + "static/media/Icon-alignment.ecc2542c.svg";